(() => {
  window.addEventListener("DOMContentLoaded", () => {
    let switchSlider = document.querySelectorAll('.switch-slider')

    switchSlider.forEach(function (item) {
      let carouselElement = item.querySelector('.ce_carousel')

      item.querySelectorAll('.ce_carousel a[data-slide="prev"]').forEach((element) => {
        element.addEventListener('click', function (e) {
          e.preventDefault()
          e.stopPropagation()

          carouselElement.Carousel.slideTo(carouselElement.Carousel.getActiveIndex() - 1)
        })
      })

      item.querySelectorAll('.ce_carousel a[data-slide="next"]').forEach((element) => {
        element.addEventListener('click', function (e) {
          e.preventDefault()
          e.stopPropagation()

          carouselElement.Carousel.slideTo(carouselElement.Carousel.getActiveIndex() + 1)
        })
      })

      item.querySelectorAll('li[data-slide-to], a[data-slide-to]').forEach((element) => {
        element.addEventListener('click', function () {
          carouselElement.Carousel.slideTo(parseInt(element.getAttribute('data-slide-to')))
        })
      })

      carouselElement.addEventListener('slide.bs.carousel', (carouselState) => {
        let index = carouselState.to
        let itemToTurnActive = item.querySelectorAll('.advantage_item')[index]

        item.querySelector('.advantage_item.active').classList.remove('active')
        itemToTurnActive.classList.add('active')
      })
    })
  })
}) ()
